import { Fragment } from 'react';

import * as Styled from 'components/SearchPage/components/Listings/Listings.styled';

import type { ListingsProps } from 'components/SearchPage/components/Listings/Listings.typed';

import { SearchCard } from 'components/SearchPage/components/Listings/components/SearchCard/SearchCard';
import { SkeletonSearchCard } from 'components/SearchPage/components/Listings/components/SkeletonSearchCard';

function Listings(props: ListingsProps) {
  const {
    listings,
    viewType,
    section,
    isLoading = false,
    createSavedAdEvent,
    deleteSavedAdEvent,
    extra,
  } = props;

  const isGrid = viewType === 'grid';

  const SKELETON_META_DATA_LENGTH = 3;

  return (
    <Styled.List data-testid="card-list" viewType={viewType}>
      {isLoading &&
        Array.apply(null, Array(15)).map((_item: null, index: number) => {
          return (
            <SkeletonSearchCard
              key={`skeleton-search-card-${index}`}
              isGrid={isGrid}
              metaDataLength={SKELETON_META_DATA_LENGTH}
            />
          );
        })}
      {!isLoading &&
        listings.map((item, index) => (
          <Fragment
            key={item.spotlight ? `spotlight-${item.id}` : `${item.id}`}
          >
            {extra &&
              extra.length &&
              extra(index).map((item, index) => (
                <Fragment key={index}>{item}</Fragment>
              ))}
            <li data-testid={`listing-card-index-${index}`}>
              <SearchCard
                item={item}
                isGrid={isGrid}
                parentSection={section}
                createSavedAdEvent={createSavedAdEvent}
                deleteSavedAdEvent={deleteSavedAdEvent}
              />
            </li>
          </Fragment>
        ))}
    </Styled.List>
  );
}

export { Listings };
